import React from 'react';
import { Login } from '@/pages/unauthenticated/Login';
import { ResetPassword } from '@/pages/unauthenticated/ResetPassword';
import { SetNewPassword } from '@/pages/unauthenticated/SetNewPassword';
import { TransactionStatus } from '@/pages/unauthenticated/TransactionStatus';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppPaths } from '@/configs/appPaths';
import { Register } from '@/pages/unauthenticated/Register';

export const UnauthenticatedApp: React.FC = () => {
	return (
		<Routes>
			<Route path={AppPaths.LOGIN} element={<Login />} />
			<Route path={AppPaths.REGISTER} element={<Register />} />

			<Route path={AppPaths.RESET_PASSWORD} element={<ResetPassword />} />
			<Route path={`${AppPaths.SET_PASSWORD}`} element={<SetNewPassword />} />
			<Route path={AppPaths.TRANSACTION_STATUS} element={<TransactionStatus />} />
			<Route path="*" element={<Navigate to={`/${AppPaths.LOGIN}`} />} />
		</Routes>
	);
};
